import React from 'react'

import { LazyBoundary } from '../components/ChunkErrorBoundary.jsx'

const DefautComponent = () => <div></div>
import ShareMultipleFilesModal from '../../resources/shareLink/practice/components/ShareMultipleFilesModal.jsx'
import ShareRequestFilesModal from '../../resources/shareLink/practice/components/ShareRequestFilesModal.jsx'
import CreateQuickTaskModal from '../../resources/quickTask/practice/components/CreateQuickTaskModal.jsx'
import UploadFilesModal from '../../resources/file/components/UploadFilesModal.jsx'
import CreateFolderModal from '../../resources/file/components/CreateFolderModal.jsx'
import ClientNotificationToggleForm from '../../resources/client/practice/components/ClientNotificationToggleForm.jsx'
import FileCopyModal from '../../resources/file/components/FileCopyModal.jsx'
import FileMoveModal from '../../resources/file/components/FileMoveModal.jsx'
import RequestListForm from '../../resources/request/components/RequestListForm.jsx'
import RequestTaskForm from '../../resources/requestTask/components/RequestTaskForm.jsx'
import RequestTaskChangesForm from '../../resources/requestTask/components/RequestTaskChangesForm.jsx'
import UploadTemplateModal from '../../resources/documentTemplate/components/UploadTemplateModal.jsx'
import CreateDocumentTemplateForm from '../../resources/documentTemplate/components/CreateDocumentTemplateForm.jsx'
import StaffClientNotificationToggleForm from '../../resources/staffClient/practice/components/StaffClientNotificationToggleForm.jsx'
import FolderPermission from '../../resources/folderPermission/components/folderPemissionModal.jsx'

/**
 * This map is imported by the share-link configuration page, whose router
 * `config/resourceRoutes.js` mounts eagerly, so every static import here
 * lands in the entry bundle on every page load. The modals that host the shared table (the three pickers, the
 * selectable staff table, the request-list bulk import, the file versions)
 * would drag TanStack, Radix, lucide and the ui/ components with them, so
 * they load on first open instead, as does the document-template apply form
 * (its tag list is on the ui/table.jsx primitives): the `null` entry renders
 * while no modal is open, and a lazy entry is rendered only once its key is
 * set.
 */
const lazyModal = loader => {
  const Lazy = React.lazy(loader)
  const LazyModal = props => (
    <LazyBoundary>
      <Lazy {...props} />
    </LazyBoundary>
  )
  return LazyModal
}

const FolderTemplateApplyForm = lazyModal(
  () =>
    import(
      '../../resources/folderTemplate/practice/components/FolderTemplateApplyForm.jsx'
    ),
)
const AttachFilesModal = lazyModal(
  () => import('../../resources/file/components/AttachFilesModal.jsx'),
)
const AttachStaffListModal = lazyModal(
  () => import('../../resources/staff/components/AttachStaffListModal.jsx'),
)
const DetachStaffListModal = lazyModal(
  () => import('../../resources/staff/components/DetachStaffListModal.jsx'),
)
const RequestListApplyForm = lazyModal(
  () => import('../../resources/request/components/RequestListApplyForm.jsx'),
)
const RequestListBulkImport = lazyModal(
  () => import('../../resources/request/components/RequestListBulkImport.jsx'),
)
const FileVersionListModal = lazyModal(
  () => import('../../resources/file/components/FileVersionListModal.jsx'),
)
const DocumentTemplateApplyForm = lazyModal(
  () =>
    import(
      '../../resources/documentTemplate/components/DocumentTemplateApplyForm.jsx'
    ),
)

const RoleModalComponent = {
  null: DefautComponent,
  file_folder_template_apply: FolderTemplateApplyForm,
  file_copy_file: FileCopyModal,
  file_move_file: FileMoveModal,
  file_reinstate_files: FileMoveModal,
  file_share_file: ShareMultipleFilesModal,
  file_request_file: ShareRequestFilesModal,
  file_signature: CreateQuickTaskModal,
  file_upload: UploadFilesModal,
  file_create_folder: CreateFolderModal,
  file_attach: AttachFilesModal,
  file_version: FileVersionListModal,
  client_notification: ClientNotificationToggleForm,
  client_new_staff_client: AttachStaffListModal,
  unassign_staff: DetachStaffListModal,
  single_request_list: RequestListForm,
  request_task_list: RequestTaskForm,
  request_task_change: RequestTaskChangesForm,
  template_upload: UploadTemplateModal,
  document_editor: CreateDocumentTemplateForm,
  document_template_upload: UploadTemplateModal,
  document_template_apply: DocumentTemplateApplyForm,
  client_staff_notification: StaffClientNotificationToggleForm,
  folder_permission: FolderPermission,
  request_list_apply: RequestListApplyForm,
  bulk_request_list: RequestListBulkImport,
}

export default RoleModalComponent
